module.exports = __webpack_public_path__ + "static/media/preview_leads.c8beea92.PNG";